import Model from "./base/model";

class TransporterLog extends Model{
  resourceName() {
    return "transporter_logs";
  }

  fields() {
    return {
      type: "",
      event: "",
      tags: "",
      created_at: "",
    };
  }
}

export default new TransporterLog();
